module.exports = "<div class=\"page-content\">\n\n</div>\n"